import { ApolloQueryResult } from '@apollo/client';
import React from 'react';
import SoldToAddressTable from './sold-to-address-table';
import { CommerceAddress, Maybe, PaymentMethod } from '@css-xp/graphtypes/src/generated-types-new';

interface ShipToAddressTabProps {
  label: string;
  disabled?: boolean;
  transactionAccountId?: string;
  billToAddress?: CommerceAddress | null;
  onComplete?: () => Promise<ApolloQueryResult<unknown>>;
  availablePaymentMethods?: Maybe<Maybe<PaymentMethod>[]> | undefined;
  hidePricingEligibility?: boolean;
  shouldForceAddAddress?: boolean;
}

const ShipToAddressTab = ({
  transactionAccountId,
  billToAddress,
  onComplete,
  availablePaymentMethods,
  hidePricingEligibility,
  shouldForceAddAddress = false,
}: ShipToAddressTabProps) => {
  return (
    <div className="ship-to-address-tab" data-testid="transaction-account-ship-to-address">
      <SoldToAddressTable
        transactionAccountId={transactionAccountId}
        billToAddress={billToAddress}
        refetch={onComplete}
        availablePaymentMethods={availablePaymentMethods}
        hidePricingEligibility={hidePricingEligibility}
        shouldForceAddAddress={shouldForceAddAddress}
      />
    </div>
  );
};

export default ShipToAddressTab;
